import React from 'react';
import { toast } from 'react-toastify';
import * as Icon from 'ubs-icons';
import { COLOR, LIMIT } from '../constant';

export const showToastSuccess = (msg) => {
    toast(
        <div className="u_toast-inner u_toast-inner-success">
            <div className="u_flex u_align-center u_content-center">
                <Icon.Checked fill={COLOR.u_green} size={18} />
                <div className="u_pl-5">
                    <p>{msg}</p>
                </div>
            </div>
        </div>
        , {
            className: 'u_toast',
            position: 'top-center',
            autoClose: LIMIT.TOAST_TIME_OUT,
            hideProgressBar: true,
            closeButton: false,
        });
}
export const showToastError = (msg) => {
    toast(
        <div className="u_toast_wrong-inner u_toast_wrong-inner-success">
            <div className="u_flex u_align-center">
                <Icon.Warning size={18} fill={COLOR.u_red} />
                <div className="u_pl-5">
                    <p>{msg}</p>
                </div>
            </div>
        </div>,
        {
            className: "u_toast_wrong",
            position: "top-center",
            autoClose: LIMIT.TOAST_TIME_OUT,
            hideProgressBar: true,
            closeButton: false,
        }
    );
};
// for admin and chat project toastMessage
export const notificationToast = (type, title, message) => {
    toast(
        <div className={`u_toast-inner u_toast-inner-${type}`}>
            <div className="u_flex u_align-center u_content-center">
                {type === 'success' && <Icon.Checked size={18} fill={COLOR.u_green} />}
                {type === 'warning' && <Icon.Warning size={18} fill={COLOR.u_red} />}
                {type === 'error' && <Icon.QuestionMark size={18} fill={COLOR.u_red} />}
                <div className="u_pl-5">
                    <p>{message}</p>
                </div>
            </div>
        </div>
        , {
            className: `${type === 'warning' || type === 'error' ? 'u_toast_wrong' : 'u_toast'}`,
            position: 'top-center',
            autoClose: LIMIT.TOAST_TIME_OUT,
            hideProgressBar: true,
            closeButton: false
        });
};
